<template>
  <div class="home-app">
    <div class="app-head">
      <h3 class="app-title">应用</h3>
      <h3 class="app-more"></h3>
    </div>
    <div class="app-list">
      <div class="app-item">
        <div class="app-img" @click="handleDdAppYskt">
          <img :src="logo1" />
        </div>
        <p>网络教研</p>
      </div>

      <div class="app-item">
        <div class="app-img" @click="handleGoCertificate">
          <img class="active" :src="logo6" />
        </div>
        <p>证书申请</p>
      </div>
      <div class="app-item">
        <div class="app-img" @click="handleDdAppJjzm">
          <img :src="logo3" />
        </div>
        <p>继教证明</p>
      </div>
      <div class="app-item">
        <div class="app-img" @click="handleGoUserInfo">
          <img :src="logo4" />
        </div>
        <p>个人信息</p>
      </div>
      <div class="app-item">
        <div class="app-img" @click="handleGoHistroy">
          <img class="active" :src="logo5" />
        </div>
        <p>观看记录</p>
      </div>
      <div class="app-item current current2">
        <div class="app-img" @click="handleShowRule">
          <img class="active" :src="logo7" />
        </div>
        <p>学时规则</p>
      </div>
      <!-- <div class="app-item current">
        <div class="app-img" @click="handleGoTrain">
          <img class="current" :src="logo10" />
        </div>
        <p>国培专区</p>
      </div> -->
      <div class="app-item current">
        <div class="app-img" @click="handleDdAppApk">
          <img class="current" :src="logo9" />
        </div>
        <p>人教专区</p>
      </div>

      <div class="app-item current">
        <div class="app-img" @click="handleGoTrain2">
          <img class="current" :src="logo11" />
        </div>
        <p>2024普高新教材培训</p>
      </div>

      <div class="app-item current">
        <div class="app-img" @click="handleGoTrain3">
          <img class="current" :src="logo12" />
        </div>
        <p>2024义教新教材培训</p>
      </div>

      <div class="app-item current">
        <div class="app-img" @click="handleGoTrain4">
          <img class="current" :src="logo12" />
        </div>
        <p>2025义教新教材培训</p>
      </div>
      <div class="app-item current">
        <div class="app-img" @click="handleGoTrain5">
          <img class="current" :src="logo12" />
        </div>
        <p>2026义教新教材培训</p>
      </div>
      <div class="app-item current">
        <div class="app-img" @click="handleGoCheck">
          <img class="current" :src="logo13" />
        </div>
        <p>活动签到</p>
      </div>

      <div class="app-item current" :class="reportShow ? 'show' : 'hide'">
        <div class="app-img" @click="handleGoReport">
          <img class="active" :src="logo8" />
        </div>
        <p>活动报告</p>
      </div>
    </div>
    <study-rule :ruleShow="ruleShow" @CloseRule="handleCloseRule"></study-rule>
  </div>
</template>

<script>
// import dd from 'dingtalk-jsapi'
import studyRule from '../../components/studyRule.vue'
export default {
  name: 'home-app',
  components: {
    studyRule
  },
  props: {
    reportShow: {
      type: Boolean
    },
    ruleShow: {
      type: Boolean
    }
  },
  data() {
    return {
      logo1: require('../../assets/image/customization/logo1.png'),
      logo9: require('../../assets/image/customization/logo9.png'),
      logo3: require('../../assets/image/customization/logo3.png'),
      logo4: require('../../assets/image/customization/logo4.png'),
      logo5: require('../../assets/image/customization/logo5.png'),
      logo6: require('../../assets/image/customization/logo6.png'),
      logo7: require('../../assets/image/customization/logo7.png'),
      logo8: require('../../assets/image/customization/logo8.png'),
      logo10: require('../../assets/image/customization/logo10.png'),
      logo11: require('../../assets/image/customization/logo11.png'),
      logo12: require('../../assets/image/customization/logo12.png'),
      logo13: require('../../assets/image/customization/logo13.png')
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  methods: {
    handleDdAppYskt() {
      this.$router.push('/discover')
    },
    handleDdAppApk() {
      this.$router.push('/alumn/1580084962135113728')
    },
    handleDdAppJjzm() {
      // if (this.appVersion === 'dd') {
      //   dd.ready(() => {
      //     dd.biz.microApp.openApp({
      //       agentId: '868059876',
      //       appId: 'dingeiuok6h2621qk18w',
      //       corpId: 'dingcc49658297bd767bf5bf40eda33b7ba0',
      //       onSuccess: result => {
      //         window.console.log('result', result)
      //       },
      //       onFail: () => {}
      //     })
      //   })
      // } else {
      //   console.log('userInfo', this.userInfo)
      //   const {phone, name} = this.userInfo
      //   // this.$router.push('/jjzm')
      //   window.location.href = `https://jjzm.k12top.com/?username=${name}&mobile=${phone}`
      // }
      this.$router.push('/newCertificate')
    },
    handleNoOpenInfo() {
      this.$Toast.fail(this.$homeOpenInfo.msg)
    },
    handleGoHistroy() {
      if (this.$homeOpenInfo.history === 0) {
        this.$router.push('/customization/history')
      } else {
        this.handleNoOpenInfo()
      }
    },
    handleGoCertificate() {
      if (this.$homeOpenInfo.apply === 0) {
        this.$router.push('/certificate/index?index=1')
      } else {
        this.handleNoOpenInfo()
      }
    },
    handleGoUserInfo() {
      if (this.$homeOpenInfo.userinfo === 0) {
        this.$router.push('/customization/user-info')
      } else {
        this.handleNoOpenInfo()
      }
    },
    handleGoReport() {
      if (this.$homeOpenInfo.report === 0) {
        this.$router.push('/customization/report')
      } else {
        this.handleNoOpenInfo()
      }
    },
    handleGoTrain() {
      this.$router.push('/alumn/1603643560844853248')
    },
    handleGoTrain2() {
      this.$router.push('/alumn/1808782235432648704')
    },
    handleGoTrain3() {
      this.$router.push('/alumn/1825365122785214464')
    },
    handleGoTrain4() {
      this.$router.push('/alumn/1945379928933400576')
    },
    handleGoTrain5() {
      this.$router.push('/alumn/2089921110345777152')
    },
    handleGoCheck() {
      localStorage.removeItem('activeTab')
      this.$router.push('/activeCheck')
    },
    handleShowRule() {
      this.$emit('show-rule')
    },
    handleCloseRule() {
      this.$emit('close-rule')
    }
  }
}
</script>

<style lang="scss" scoped>
.home-app {
  .app-head {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .app-title {
      font-size: 17px;
      font-weight: 700;
    }
    .app-more {
      font-weight: 500;
      font-size: 13px;
      color: #909399;
    }
  }
  .app-list {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 12px;
    /* display: flex; */
    /* flex-direction: row; */
    /* justify-content: flex-start; */
    /* flex-wrap: wrap; */
    .app-item {
      /* display: inline-block; */
      /* margin-bottom: 22px; */
      /* flex: 0 0 25%; */
      /* width: 2.28rem; */
      /* display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center; */
      margin-bottom: 22px;
      width: 25%;
      &.current {
        margin-bottom: 0;
      }

      &.show {
        /* visibility: visible; */
        display: block;
      }
      &.hide {
        display: none;
        /* visibility: hidden; */
      }
      .app-img {
        margin-left: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60px;
        height: 60px;
        background-color: #fff;
        box-shadow: 0px 0px 5px 0px rgba(48, 49, 51, 0.05);
        border-radius: 10px;
        img {
          width: 50px;
          height: 50px;
          &.current {
            width: 45px;
            height: 45px;
          }
          &.active {
            width: 36px;
            height: 36px;
          }
        }
      }
      p {
        /* margin-left: 12px; */
        margin-top: 16px;
        padding-right: 12px;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
        color: #28292b;
        letter-spacing: 1px;
      }
    }
  }
}
</style>
